module.exports = __webpack_public_path__ + "img/7.48f7e77c.jpg";